import { render, staticRenderFns } from "./MakePaymentTransfer.vue?vue&type=template&id=148d5237&"
import script from "./MakePaymentTransfer.vue?vue&type=script&lang=js&"
export * from "./MakePaymentTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports